var _circle, _path, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBot({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#2E2E2E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 7C10.9248 7 6 11.1589 6 16.289C6 18.9323 6.94993 21.7752 9.04852 23.4667C9.0217 24.2732 8.22482 25.3598 7.72329 26C8.6956 25.962 10.9572 25.2578 11.6896 24.6303C13.3632 25.499 15.3332 26 17.4416 26C23.5167 26 28 22.6222 28 16.289C28 11.1589 23.075 7 16.9999 7ZM23.8366 20.7901C23.4312 21.2285 22.8536 21.4749 22.2504 21.4749H11.7493C11.1462 21.4749 10.5685 21.2285 10.1631 20.7901C9.01522 19.5485 8.33116 17.9861 8.33116 16.2888C8.33116 14.5915 9.01508 13.0292 10.163 11.7877C10.5684 11.3491 11.146 11.1027 11.7493 11.1027H22.2503C22.861 11.1027 23.4418 11.3581 23.8508 11.8029C24.9903 13.0419 25.6686 14.5985 25.6686 16.2887C25.6686 17.9789 24.9845 19.5485 23.8366 20.7901Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 16.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 16.5,
    r: 1.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot);
export default __webpack_public_path__ + "static/media/bot.2ee6b3c70b4473e462cdad7adab39dda.svg";
export { ForwardRef as ReactComponent };